import { AxiosResponse } from 'axios';
import { handleParameter } from 'ducks/parameters/utils';
import { updateSettings } from 'ducks/settings/slices';
import { ParametersItem, ProjectParameterItem } from 'ducks/types/store-types';
import { store } from 'store';
import { Andromeda } from 'utils/axios';

export const updateParameters = async (route: string, data: (ParametersItem | ProjectParameterItem)[]) => {
  store.dispatch(updateSettings({ loading: true }));
  const payload = handleParameter(data);
  const res: AxiosResponse['data'] = await Promise.all(
    payload.map((p) => Andromeda.post(`${route}/${p.parameter_name_old}/update`, p)),
  );
  return res.data;
};

export const deleteParameters = async (route: string, data: (ParametersItem | ProjectParameterItem)[]) => {
  store.dispatch(updateSettings({ loading: true }));
  const res: AxiosResponse['data'] = await Promise.all(
    data.map((p) => {
      if (!('parameter_name_old' in p)) return;
      Andromeda.post(`${route}/${p.parameter_name_old}/delete`, {});
    }),
  );
  return res.data;
};

export const createParameters = async (route: string, data: (ParametersItem | ProjectParameterItem)[]) => {
  store.dispatch(updateSettings({ loading: true }));
  const payload = handleParameter(data);
  const res: AxiosResponse['data'] = await Promise.all(
    payload.map((p) => Andromeda.post(`${route}/${p.parameter_name}/create`, p)),
  );
  return res.data;
};
